import DateInput from '../../../common2/DateInput';
import React from 'react';

type ConditionalDeliveryInputProps = {
  deliveryDate?: Date | null;
  warehouseDeliveryDate?: Date | null;
  postalReturnDeliveryDate?: Date | null;
};

// disabled because they are filled a previous step
function ConditionalDeliveryInput(props: ConditionalDeliveryInputProps) {
  const { deliveryDate, postalReturnDeliveryDate, warehouseDeliveryDate } = props;
  const showDeliveryInfo = !!deliveryDate || !!postalReturnDeliveryDate;
  const showWarehouseDeliveryDate = !!warehouseDeliveryDate;

  if (showWarehouseDeliveryDate) {
    return (
      <DateInput
        name="warehouseDeliveryDate"
        label={'Warehouse delivery date'}
        value={warehouseDeliveryDate}
        disabled
        isRequired
        onChange={() => {}}
      />
    );
  } else if (showDeliveryInfo) {
    return (
      <DateInput
        name="deliveryDate"
        label={deliveryDate ? 'Delivery date' : 'Postal return delivery date'}
        placeholder="Add delivery date"
        value={deliveryDate || postalReturnDeliveryDate}
        onChange={() => {}}
        isRequired
        disabled
      />
    );
  } else {
    return <div />;
  }
}

export default React.memo(ConditionalDeliveryInput);
